module.exports = new __parcel__URL__("nasa_headquarters.516421df.png").toString();